import DisconnectIntegrationModal from './DisconnectIntegrationModal.Container';

export default DisconnectIntegrationModal;
